import { bl_applet_label_ext_RowInterface, bl_applet_label_hdr_RowClass } from '../../../dbschema';
import {BaseContainerModel} from '../../base-container.model';

export class AppletLabelContainerModel extends BaseContainerModel {
    bl_applet_label_hdr: bl_applet_label_hdr_RowClass = new bl_applet_label_hdr_RowClass();
    bl_applet_label_exts: Array<bl_applet_label_ext_RowInterface> = [];
}
